//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'
import { mapState, mapGetters, mapMutations } from 'vuex'
import menuSide from './components/menu-side'
import menuHeader from './components/menu-header'
import tabs from './components/tabs'
import headerUser from './components/header-user'
export default {
  name: 'd2-layout-header-aside',
  components: {
    'd2-menu-side': menuSide,
    'd2-menu-header': menuHeader,
    'd2-tabs': tabs,
    'd2-header-user': headerUser
  },
  data () {
    return {
      // [侧边栏宽度] 正常状态
      asideWidth: '200px',
      // [侧边栏宽度] 折叠状态
      asideWidthCollapse: '65px',
      headerState:window.sessionStorage.getItem('state')
    }
  },
  computed: {
    ...mapState({
      pageOpenedList: state => state.d2admin.pageOpenedList,
      isMenuAsideCollapse: state => state.d2admin.isMenuAsideCollapse
    }),
    ...mapGetters([
      'd2adminThemeActiveSetting',
      'd2adminKeepAliveInclude'
    ]),
    /**
     * @description 最外层容器的背景图片样式
     */
    styleLayoutMainGroup () {
      return {
        ...this.d2adminThemeActiveSetting.backgroundImage ? {
          backgroundImage: `url('${this.$baseUrl}${this.d2adminThemeActiveSetting.backgroundImage}')`
        } : {}
      }
    }
  },
  mounted () {
    this.$io.init()
    if(window.sessionStorage.getItem('state') === 'true') return
    console.log(window.sessionStorage.getItem('state'))
    this.$axios.get('/mtea/store/admin/msg/unReadCount', { params: {} }).then(res => {
      let count = _.reduce(res, (memo, item) => { return memo + item.count }, 0);
      this.$bus.$emit('menuDotShow', { menu: { path: '/operate/msg/tabs' }, count: count})
    })
  },
  methods: {
    ...mapMutations([
      'd2adminMenuAsideCollapseToggle'
    ]),
    /**
     * 接收点击切换侧边栏的按钮
     */
    handleToggleAside () {
      this.d2adminMenuAsideCollapseToggle()
    }
  }
}
